<script>
import {
    Icon3dCubeSphere,
    IconAward,
    IconBadge,
    IconBrandCodesandbox,
    IconCards,
    IconComponents,
    IconDeviceDesktopAnalytics,
    IconHealthRecognition,
    IconHeartHandshake,
    IconId,
    IconMap,
    IconNews,
    IconSettings,
} from '@tabler/icons-vue';

export default {
    components: {
        rewards: IconAward,
        items: Icon3dCubeSphere,
        card_collections: IconCards,
        badges: IconBadge,
        battles: IconHeartHandshake,
        fetch_quests: IconComponents,
        chests: IconBrandCodesandbox,
        settings: IconSettings,
        actions: IconDeviceDesktopAnalytics,
        health_amounts: IconHealthRecognition,
        announcements: IconNews,
        itineraries: IconMap,
        character_types: IconId,
    },
    props: {
        section: {
            required: true,
            type: String,
        },
    },
};
</script>

<template>
    <component :is="section" />
</template>
